import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DefaultFaq {
    DefaultfaqDetails: any;
}

interface DefaultFaqState {
    value: DefaultFaq;
}

const initialState: DefaultFaqState = {
    value :{
        DefaultfaqDetails: [],
    }
};



const setDefaultFaqSlice = createSlice({
  name: "setDefaultFaq",
  initialState: initialState,
  reducers: {
    addFaq: (state,  action: PayloadAction<string>) => {
      state.value.DefaultfaqDetails = action.payload;
    }
  }
});

export const { addFaq } = setDefaultFaqSlice.actions;

export default setDefaultFaqSlice.reducer;